import React from "react";
import ReactAnimatedWeather from 'react-animated-weather';

import "./Weather.css"

export default function WeatherIcons(props) {
    const codeMapping = {
        "01d": "CLEAR_DAY",
        "01n": "CLEAR_NIGHT",
        "02d": "PARTLY_CLOUDY_DAY",
        "02n": "PARTLY_CLOUDY_NIGHT",
        "03d": "CLOUDY",
        "03n": "CLOUDY",
        "04d": "CLOUDY",
        "04n": "CLOUDY",
        "09d": "CLOUDY",
        "09n": "CLOUDY",
        "10d": "RAIN",
        "10n": "RAIN",
        "11d": "RAIN",
        "11n": "RAIN",
        "13d": "RAIN",
        "13n": "RAIN",
        "50d": "FOG",
        "50n": "FOG"
    }
    
    let icon = props.code;

    function colorpicker() {
        if (icon.endsWith('d') === true) {
            return "#d2b48c"
        } else {
            return "#d2b48c"
        }
    }
    
    return (
        <ReactAnimatedWeather
            icon={codeMapping[props.code]}
            color= {colorpicker()}
            size={74}
            animate={true}
        />
    )
}